
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt/sub/mobili-versija",
      function () {
        return require("private-next-pages/lt/sub/mobili-versija.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt/sub/mobili-versija"])
      });
    }
  